<loading [visible]="loading()"></loading>

@if(!loading()){
<app-custom-modal customTitle="Configuración Verifactu" [hideFooter]="true" (closeFunction)="closeFormFunction()">

    <div class="space-y-6">

        <!-- <div>
            <label class="flex items-center gap-3 cursor-pointer">
                <input type="checkbox" [formControl]="autoSendControl"
                    class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer" />
                <span class="text-sm text-gray-700">Enviar facturas a Verifactu automáticamente al crearlas</span>
            </label>
            <p class="text-xs text-gray-400 mt-1 ml-7">
                Si está desactivado, las facturas quedarán pendientes y podrás enviarlas manualmente desde "Facturas pendientes de Verifactu".
            </p>

            <div class="mt-2 flex justify-end">
                <button type="button" (click)="saveAutoSend()" [disabled]="savingAutoSend"
                    class="px-4 py-1.5 bg-indigo-600 text-white text-xs font-semibold uppercase tracking-wider rounded-lg hover:bg-indigo-700 transition-colors disabled:opacity-50">
                    {{ savingAutoSend ? 'Guardando...' : 'Guardar' }}
                </button>
            </div>
        </div> -->

        <div class="pt-4 border-t border-gray-100">
            <div class="flex items-center justify-between mb-2">
                <label class="text-xs font-medium text-gray-600 uppercase tracking-wide">
                    Certificado digital (.p12 / .pfx)
                </label>
                <span class="text-xs px-1.5 py-0.5 rounded"
                    [class.bg-green-50]="certConfigured" [class.text-green-600]="certConfigured"
                    [class.bg-gray-100]="!certConfigured" [class.text-gray-500]="!certConfigured">
                    {{ certConfigured ? 'Configurado' : 'No configurado' }}
                </span>
            </div>

            <div class="relative mb-2">
                <input #certPasswordInput type="password" placeholder="Contraseña del certificado" [formControl]="certPasswordControl"
                    class="w-full border border-gray-200 rounded-lg pl-3 pr-9 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-300" />
                <password-toggle [input]="certPasswordInput" />
            </div>

            <label
                class="flex flex-col items-center justify-center w-full h-24 border-2 border-dashed rounded-lg cursor-pointer transition-colors"
                [class.border-indigo-300]="selectedFile"
                [class.bg-indigo-50]="selectedFile"
                [class.border-gray-200]="!selectedFile"
                [class.bg-gray-50]="!selectedFile">
                <input type="file" class="hidden" accept=".p12,.pfx" (change)="onFileChange($event)" />
                @if(selectedFile){
                <span class="text-xs font-medium text-indigo-600 text-center px-2 truncate max-w-full">{{ selectedFile.name }}</span>
                } @else {
                <span class="text-xs text-gray-400">Haz clic para seleccionar el archivo</span>
                }
            </label>

            @if(certError){
            <p class="text-xs text-red-500 mt-1">{{ certError }}</p>
            }

            <div class="mt-3 flex justify-end gap-2">
                @if(certConfigured){
                <button type="button" (click)="deleteCert()" [disabled]="deletingCert"
                    class="px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-red-600 border border-red-200 rounded-lg hover:bg-red-50 transition-colors disabled:opacity-50">
                    {{ deletingCert ? 'Eliminando...' : 'Eliminar certificado' }}
                </button>
                }
                <button type="button" (click)="uploadCert()" [disabled]="uploadingCert"
                    class="px-4 py-1.5 bg-indigo-600 text-white text-xs font-semibold uppercase tracking-wider rounded-lg hover:bg-indigo-700 transition-colors disabled:opacity-50">
                    {{ uploadingCert ? 'Guardando...' : (certConfigured ? 'Reemplazar' : 'Guardar certificado') }}
                </button>
            </div>
        </div>

    </div>
</app-custom-modal>
}
